const typography = {
  fonts: {
    body: 'AbelPro, AbelProLocalFallback, system-ui, sans-serif',
    heading: 'URWDINCondensed, URWDINCondensedLocalFallback, sans-serif',
    monospace: 'Menlo, monospace'
  },
  rtlFonts: {
    body: 'Almarai, AlmaraiLocalFallback, system-ui, sans-serif',
    heading: 'Cairo, CairoLocalFallback, sans-serif'
  }
};

export { typography };
